import React from "react";

interface SpacerProps extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> {
  reset?: boolean;
  validity?: {};
}

function Spacer({
  children,
  onChange,
  reset = false,
  validity,
  className,
}: SpacerProps) {
  const elements = React.Children.toArray(children) as any[];

  return (
    <div className={className}>
      {" "}
      {elements.map((value) =>
        React.cloneElement(value, {
          onChange: onChange,
          validity,
          ...(reset &&
          (value?.props?.name ||
            value?.props?.validationRules ||
            value?.props?.required)
            ? { reset }
            : {}),
          ...value.props,
        }),
      )}{" "}
    </div>
  );
}

export default Spacer;
